import React from "react"

import RatingByLine from "components/common/rating-by-line"
import {
  ProductDescription,
  ProductHeader,
  ProductInfo,
  ProductIngredients,
  ProductRatingWrapper,
  ProductTitleWrapper,
} from "./styles"

const SupplementProductDescription = ({ product, dataId, showReviewRating, ...props }) => (
  <ProductDescription data-exp-id={dataId} {...props}>
    {product && (
      <>
        <ProductHeader enabled={product.overrides.headline || product.metaHeaderEnable?.value}>
          <h2
            dangerouslySetInnerHTML={{
              __html: product.overrides.headline
                ? product.overrides.headline.childMarkdownRemark.html
                : product?.metaHeaderHtml?.value,
            }}
          />
        </ProductHeader>
        <ProductTitleWrapper>
          {product.title && (
            <h3>
              {product.overrides.productName
                ? product.overrides.productName
                : product?.metaProductDisplayTitle?.value
                ? product?.metaProductDisplayTitle?.value
                : product.title}
            </h3>
          )}
          {showReviewRating && (
            <ProductRatingWrapper>
              <RatingByLine
                rating={product.review?.productScore || 0}
                reviewCount={product.review?.totalReviews || 0}
              />
            </ProductRatingWrapper>
          )}
        </ProductTitleWrapper>
        <ProductIngredients
          dangerouslySetInnerHTML={{
            __html: product.overrides.subheadline
              ? product.overrides.subheadline.childMarkdownRemark.html
              : product.metaIngredientsListHtml?.value,
          }}
        />
        <ProductInfo
          dangerouslySetInnerHTML={{
            __html: product.overrides.description
              ? product.overrides.description.childMarkdownRemark.html
              : JSON.parse(product.metaProductDescription?.value).html,
          }}
        />
      </>
    )}
  </ProductDescription>
)

export default SupplementProductDescription
